// ── DB 관리 — 스타일 상수 ─────────────────────────────────────────────────────
import {
  stdModalHeaderBar, stdModalHeaderIconBox, stdModalHeaderTitle, stdModalHeaderSub, stdModalCloseBtn,
} from '../adminlayout/designStandard';

export const pageStyle      = { padding: '0 0 40px' };
export const pageTitleStyle = { margin: '0 0 4px', fontSize: 20, fontWeight: 800, color: 'var(--text)' };
export const pageDescStyle  = { margin: '0 0 20px', fontSize: 13, color: 'var(--text-muted)' };

/* 데스크톱 2컬럼 레이아웃: 왼쪽 테이블 목록 패널 + 오른쪽 상세 패널 */
export const layoutStyle = {
  display: 'grid',
  gridTemplateColumns: '280px 1fr',
  gap: 16,
  alignItems: 'start',
};

/* 테이블 목록 패널 (데스크톱): 세로 스크롤 + sticky 배치 — 디자인 표준: 라운드 8·그림자 없음 */
export const tableListPanelStyle = {
  background: 'var(--bg-card)', borderRadius: 8, border: '1px solid var(--border)',
  boxShadow: 'none', overflow: 'hidden',
  position: 'sticky', top: 20, maxHeight: 'calc(100vh - 80px)',
  overflowY: 'auto', display: 'flex', flexDirection: 'column',
};

/* 패널 상단 헤더: 제목 + 테이블 수 뱃지 */
export const panelHeaderStyle = {
  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  padding: '12px 14px 8px', borderBottom: '1px solid var(--bg-subtle)',
};

export const panelTitleStyle = { fontSize: 13, fontWeight: 800, color: 'var(--text)' };

/* 테이블 수 뱃지 — 디자인 표준 배지 톤(연파랑+파랑) */
export const badgeStyle = {
  fontSize: 11, fontWeight: 700, color: 'var(--std-badge-text, #1d7de6)',
  background: 'var(--std-badge-bg, rgba(59,154,242,0.12))', borderRadius: 999, padding: '1px 7px',
};

/* 테이블 목록 검색 입력 */
export const searchInputStyle = {
  margin: '8px 10px', padding: '6px 10px',
  border: '1px solid var(--border)', borderRadius: 8,
  fontSize: 12, outline: 'none', width: 'calc(100% - 20px)',
  color: 'var(--text)', background: 'var(--bg-card)',
};

/* 테이블 행 버튼: 기본 / 활성 두 가지 상태 */
export const tableRowBtnStyle = {
  width: '100%', textAlign: 'left', border: 'none', background: 'transparent',
  padding: '8px 14px', cursor: 'pointer', borderBottom: '1px solid var(--bg-subtle)',
  transition: 'background 0.1s',
};
// 활성 = 디자인 표준 알약·사이드바 활성과 같은 연파랑 배경 (색 굵은 테두리 제거)
export const tableRowBtnActiveStyle = { background: 'var(--std-badge-bg, rgba(59,154,242,0.12))' };

/* 테이블명 표시 (모노스페이스) */
export const tableNameStyle = {
  display: 'block', fontSize: 12, fontWeight: 700, color: 'var(--text-sub)', fontFamily: 'monospace',
};
/* 테이블 목록 — 기능 설명 한 줄 (이탤릭 잘림) */
export const tableDescStyle = {
  display: 'block', fontSize: 10, color: 'var(--text-muted)', marginTop: 1,
  fontStyle: 'italic', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
};
export const tableMetaStyle = { display: 'flex', gap: 4, fontSize: 10, color: 'var(--text-muted)', marginTop: 2 };

/* 상세 헤더 — 기능 설명 + 관련 페이지 배지 */
export const tableDescHeaderStyle = { fontSize: 12, color: 'var(--text-sub)', fontStyle: 'italic' };
export const pageTagStyle = {
  display: 'inline-block', fontSize: 10, fontWeight: 600,
  color: 'var(--std-badge-text, #1d7de6)', background: 'var(--std-badge-bg, rgba(59,154,242,0.12))', border: 'none',
  borderRadius: 99, padding: '1px 7px',
};
export const noteTagStyle = {
  display: 'inline-block', fontSize: 10, fontWeight: 500,
  color: '#92400e', background: '#fffbeb', border: '1px solid #fcd34d',
  borderRadius: 99, padding: '1px 7px', maxWidth: 260,
  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'help',
};

/* 상세 패널 (데스크톱) — 디자인 표준: 라운드 8·그림자 없음 */
export const detailPanelStyle = {
  background: 'var(--bg-card)', borderRadius: 8, border: '1px solid var(--border)',
  boxShadow: 'none', minHeight: 400, overflow: 'hidden',
};

/* 빈 상태 (테이블 미선택) */
export const emptyStateStyle = {
  display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
  height: 300, color: 'var(--text-muted)',
};

/* 상세 패널 헤더: 테이블명 + 저장 결과 메시지 */
export const detailHeaderStyle = {
  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  padding: '16px 18px 12px', borderBottom: '1px solid var(--bg-subtle)',
};

export const detailTitleStyle = {
  margin: 0, fontSize: 16, fontWeight: 800, color: 'var(--text)', fontFamily: 'monospace',
};
export const detailSubStyle = { fontSize: 12, color: 'var(--text-muted)', marginTop: 2, display: 'block' };

/* 스키마/데이터 탭 행 — 디자인 표준 알약 토글(연파랑 활성, 밑줄 탭 제거) */
export const tabRowStyle = {
  display: 'inline-flex', background: 'var(--bg-subtle)',
  borderRadius: 999, padding: 3, margin: '12px 18px 4px',
};
export const tabBtnStyle = (active) => (active
  ? {
      background: 'var(--std-pill-on-bg, rgba(59,154,242,0.12))', borderRadius: 999, padding: '5px 14px',
      fontWeight: 700, fontSize: 12, border: 'none', cursor: 'pointer', color: 'var(--std-pill-on-text, #1d7de6)',
    }
  : {
      background: 'transparent', border: 'none', padding: '5px 14px',
      fontWeight: 600, fontSize: 12, color: 'var(--text-muted)', cursor: 'pointer', borderRadius: 999,
    });

/* 섹션 타이틀 바 (컬럼/인덱스/FK 소제목) */
export const sectionTitleBarStyle = {
  fontSize: 12, fontWeight: 800, color: 'var(--text-sub)',
  padding: '10px 18px 6px', textTransform: 'uppercase', letterSpacing: '0.06em',
};

/* 공통 테이블 스타일 */
export const tableWrapStyle = { overflowX: 'auto', WebkitOverflowScrolling: 'touch' };
export const tblStyle       = { width: '100%', borderCollapse: 'collapse', fontSize: 12 };
export const thStyle        = {
  // 디자인 표준: 검정 머리글 띠(흰 글씨, 검정 버튼과 동일 톤)
  padding: '10px 12px', background: 'var(--std-thead, #0f172a)', borderBottom: 'none',
  textAlign: 'left', fontSize: 11, fontWeight: 600, color: 'rgba(255,255,255,0.92)',
  letterSpacing: '0.04em', whiteSpace: 'nowrap', textTransform: 'uppercase',
};
export const trStyle = () => ({ background: 'var(--bg-card)' });
export const tdStyle        = {
  padding: '6px 12px', borderBottom: '1px solid var(--bg-subtle)',
  color: 'var(--text-sub)', verticalAlign: 'middle', whiteSpace: 'nowrap',
};

/* 행 편집 버튼 (연필 아이콘) */
export const editRowBtnStyle = {
  border: '1px solid var(--border)', borderRadius: 5, padding: '2px 5px',
  background: 'var(--bg-subtle)', cursor: 'pointer', fontSize: 12, lineHeight: 1,
};

/* 컬럼 메타 스타일 */
export const ordinalStyle   = { color: 'var(--text-muted)', fontSize: 11, fontVariantNumeric: 'tabular-nums' };
export const colNameStyle   = { fontFamily: 'monospace', fontWeight: 700, color: 'var(--text-sub)', fontSize: 12 };
export const typeBadgeStyle = {
  display: 'inline-block', padding: '1px 7px', borderRadius: 6,
  fontSize: 11, fontWeight: 700, fontFamily: 'monospace',
};
export const sensitiveBadgeStyle = {
  fontSize: 10, fontWeight: 700, color: '#dc2626',
  background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 6, padding: '1px 6px',
};
export const pkBadgeStyle = {
  fontSize: 10, fontWeight: 800, color: '#7c3aed',
  background: '#f3e8ff', border: '1px solid #ddd6fe', borderRadius: 6, padding: '1px 6px',
};
export const uniqueBadgeStyle = {
  fontSize: 10, fontWeight: 700, color: '#0369a1',
  background: '#e0f2fe', border: '1px solid #bae6fd', borderRadius: 6, padding: '1px 6px',
};

export const placeholderStyle = { padding: 32, textAlign: 'center', color: 'var(--text-muted)', fontSize: 13 };

/* ── 모바일 전용 스타일 ── */

/** DB 관리 — 모바일 테이블 목록 패널 (sticky 제거, 전체 너비) — 디자인 표준: 그림자 없음 */
export const mobileTableListPanelStyle = {
  background: 'var(--bg-card)', borderRadius: 8, border: '1px solid var(--border)',
  boxShadow: 'none', overflow: 'hidden',
  display: 'flex', flexDirection: 'column',
};

/** DB 관리 — 모바일 상세 패널 (전체 너비) — 디자인 표준: 그림자 없음 */
export const mobileDetailPanelStyle = {
  background: 'var(--bg-card)', borderRadius: 8, border: '1px solid var(--border)',
  boxShadow: 'none', minHeight: 400, overflow: 'hidden',
};

/** 뒤로가기 버튼 (모바일 상세 패널 상단) */
export const mobileBackBtnStyle = {
  display: 'flex', alignItems: 'center', gap: 4,
  padding: '10px 14px', border: 'none', borderBottom: '1px solid var(--bg-subtle)',
  background: 'var(--bg-subtle)', color: 'var(--std-accent-text, #1d7de6)', fontSize: 13, fontWeight: 700,
  cursor: 'pointer', width: '100%', textAlign: 'left',
};

/** 스키마 — 모바일 컬럼 카드 */
export const mobileColCardStyle = {
  background: 'var(--bg-subtle)', border: '1px solid var(--border)',
  borderRadius: 8, padding: '8px 10px',
};

/** 데이터 — 모바일 행 카드 */
export const mobileDataRowCardStyle = {
  background: 'var(--bg-card)', border: '1px solid var(--border)',
  borderRadius: 10, padding: '10px 12px',
};
export const mobileDataFieldStyle = {
  display: 'grid', gridTemplateColumns: '120px 1fr',
  gap: 6, fontSize: 11, alignItems: 'start',
};
export const mobileDataLabelStyle = {
  color: 'var(--text-muted)', fontFamily: 'monospace', fontWeight: 700,
  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
};
export const mobileDataValueStyle = {
  color: 'var(--text-sub)', fontSize: 11,
  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
};

/** 데이터 뷰 정보 바 (전체 건수 + 페이지) */
export const dataInfoBarStyle = {
  display: 'flex', gap: 8, alignItems: 'center',
  padding: '10px 18px', fontSize: 12, color: 'var(--text-muted)',
  background: 'var(--bg-subtle)', borderBottom: '1px solid var(--bg-subtle)',
};

/* 페이지네이션 */
export const paginationStyle = { display: 'flex', gap: 4, justifyContent: 'center', padding: '14px 18px' };
export const pageBtnStyle = (active) => ({
  padding: '4px 9px',
  border: `1px solid ${active ? 'var(--std-btn, #0f172a)' : 'var(--border)'}`,
  borderRadius: 6,
  background: active ? 'var(--std-btn, #0f172a)' : 'var(--bg-card)',
  color: active ? '#fff' : 'var(--text-sub)',
  fontSize: 12, fontWeight: active ? 700 : 500, cursor: 'pointer',
});

/* ── 행 편집 모달 스타일 ── */

export const modalOverlayStyle = {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
  zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
};
export const modalBoxStyle = {
  background: 'var(--bg-card)', borderRadius: 14, width: '100%', maxWidth: 600,
  maxHeight: '85vh', display: 'flex', flexDirection: 'column',
  boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
};
// 모달 헤더 — 디자인 표준: 검정 밴드 + 아이콘 박스 + 흰 제목 (카드 라운드 14에 맞춤)
export const modalHeaderStyle = stdModalHeaderBar(14);
export const modalHeaderLeftStyle = { display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 };
export const modalHeaderIconBoxStyle = stdModalHeaderIconBox;
export const modalHeaderTitleStyle = { ...stdModalHeaderTitle, fontFamily: 'monospace' };
export const modalHeaderSubStyle = stdModalHeaderSub;
export const modalCloseBtnStyle = stdModalCloseBtn;
export const readonlyChipStyle = {
  display: 'inline-flex', alignItems: 'center',
  background: 'var(--bg-subtle)', border: '1px solid var(--border)',
  borderRadius: 8, padding: '3px 8px', fontSize: 11,
};
export const fieldLabelStyle = {
  display: 'block', fontSize: 11, fontWeight: 700, color: 'var(--text-sub)',
  marginBottom: 4, fontFamily: 'monospace',
};
export const fieldInputStyle = {
  width: '100%', padding: '7px 10px', border: '1px solid var(--border)',
  borderRadius: 8, fontSize: 12, outline: 'none', boxSizing: 'border-box',
  fontFamily: 'monospace',
};
export const textareaStyle = {
  width: '100%', padding: '7px 10px', border: '1px solid var(--border)',
  borderRadius: 8, fontSize: 12, outline: 'none', boxSizing: 'border-box',
  fontFamily: 'monospace', resize: 'vertical',
};
export const modalFooterStyle = {
  display: 'flex', justifyContent: 'flex-end', gap: 8,
  padding: '12px 20px', borderTop: '1px solid var(--bg-subtle)',
};
export const cancelBtnStyle = {
  border: '1px solid var(--border)', borderRadius: 8, padding: '7px 18px',
  background: 'var(--bg-card)', color: 'var(--text-sub)', fontWeight: 600, fontSize: 13, cursor: 'pointer',
};
export const saveBtnStyle = {
  // 디자인 표준: 주요 버튼 = 검정 박스 (보라 그라데이션 제거)
  border: '1px solid var(--std-btn, #0f172a)', borderRadius: 8, padding: '7px 20px',
  background: 'var(--std-btn, #0f172a)',
  color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer',
};
